export class ExchangeWithdraw {
  public userEmail: string;
  public apiMessage: string;
  public amount: number;
  public date: string;
  public linkTransactionHash: string;
  public tokenName: string;
  public status: string;
  public amountByTransaction: string;
  public success: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/exchangeWithdraw.model.ts